import React from 'react';
import type { PropsWithChildren } from 'react';
import useHashParam from 'use-hash-param';

import { BookIdContext } from './BookIdContext';

type BookIdProviderProps = PropsWithChildren<{}>;

export function BookIdProvider({ children }: BookIdProviderProps) {
  const [bookId, setBookId] = useHashParam('bookId', '');
  return (
    <BookIdContext.Provider
      value={{
        bookId,
        setBookId,
      }}
    >
      {children}
    </BookIdContext.Provider>
  );
}
